<div class="summary-part"
     *ngIf="!cs.step3.skipped">
    <div class="summary-part-title">
        <div class="title">{{ 'ITSM.CREATESERVICEREQUEST.STEPS.STEP3.TAB' | translate }}</div>
        <div class="action"
             (click)="gotoStep(2)">{{ 'BUTTON.MODIFY' | translate }}</div>
    </div>
    <ng-container *ngIf="cs.step3.valid">
        <div class="summary-part-row">
            <div class="summary-field value"
                 [innerHTML]="cs.step3.message"></div>
        </div>
    </ng-container>
    <ng-container *ngIf="!cs.step3.valid">
        <div class="summary-part-row">
            {{ 'ITSM.CREATESERVICEREQUEST.STEPS.NOTCOMPLETED' | translate }}
        </div>
    </ng-container>
    <hr />
</div>
